import RegistrationStepper from "@/page/registration/RegistrationStepper";

export default function RegistrationPage() {
  return <RegistrationStepper />;
}
